import { TEARSHEET_VERSION } from 'api/tearsheetApi';
import Underwriting from './Underwriting';

const UnderwritingNew = () => {
  return (
    <Underwriting
      tearsheetVersion={TEARSHEET_VERSION.V2}
      underwritingBasePath={'underwriting_new'}
    />
  );
};

UnderwritingNew.propTypes = {};

export default UnderwritingNew;
